import { render, staticRenderFns } from "./DiseaseTag.vue?vue&type=template&id=5f802adb&scoped=true&"
import script from "./DiseaseTag.vue?vue&type=script&lang=js&"
export * from "./DiseaseTag.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseTag.vue?vue&type=style&index=0&id=5f802adb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f802adb",
  null
  
)

export default component.exports